import React, { Component } from "react";
import { can } from "../../utils/permission";
import {
  company,
  loading,
  NavbarAdmin,
  Modal,
  Pagination,
  Select,
  GET,
  POST,
  PUT,
  DELETE,
  UPLOAD,
  alert,
  t,
  activeOptions,
  sortOptions,
} from "../../components/CustomComponent.js";
import { compressImageFile } from "../../utils/fileUpload";

// เพดานไฟล์ลายเซ็นที่อัปโหลดได้ (ISS-033) - ใช้ตัวเลขเดียวกับฝั่งแอปมือถือ
const SIGNATURE_MAX_SIZE = 2 * 1024 * 1024;

export default class Technicians extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // -----------------------------------
      // Data & Filter States
      // -----------------------------------
      data: [],
      data_skill: [],
      data_departments: [], // แผนก (สำหรับ dropdown สิทธิ์)
      data_roles: [], // บทบาท (Role)
      data_supervisors: [], // ผู้บังคับบัญชา
      count: 0,
      page: 1,
      page_size: 10,
      filter_search: "",
      
      // -----------------------------------
      // Modal States
      // -----------------------------------
      modal_create: false,
      modal_update: false,
      uid: "", // เก็บ id สำหรับตอนอัปเดต

      // -----------------------------------
      // Form States (อิงตาม Payload)
      // -----------------------------------
      emp_id: "", // technician_code
      company_id: company?.id || "", // company_id จะถูกตั้งอัตโนมัติจาก global company
      
      // ข้อมูลภาษาไทย
      title_th: "นาย", // perfix_name
      fname_th: "", // first_name_th
      lname_th: "", // last_name_th
      nickname_th: "", // nickname_th
      status: "active",
      filter_status: "", // ตัวกรองสถานะบนลิสต์ ("" = ทั้งหมด)
      
      // ข้อมูลภาษาอังกฤษ
      title_en: "Mr.", // perfix_name_en
      fname_en: "", // first_name_en
      lname_en: "", // last_name_en
      nickname_en: "", // nickname_en
      
      // ข้อมูลการติดต่อ
      phone: "",
      email: "",
      
      // ข้อมูลธนาคารและพาหนะ
      bank: "SCB", // bank_code / bank_name
      account_no: "", // bank_account_number
      account_name: "", // bank_account_name
      has_car: true, // is_car
      has_motorcycle: false, // is_motorcycle

      // ความชำนาญเครื่องพิมพ์ (technician_skill)
      printers: [],
      new_printer_select: "",

      // สิทธิ์การใช้งานระบบ (User Authorization)
      password: "",
      show_password: false,
      has_login_user: false, // technician นี้มี user (รหัสผ่าน) แล้วหรือยัง — ใช้ซ่อน input password ตอนแก้ไข
      department_id: "", // แผนกต้นสังกัด (uid)
      user_type: "technician", // ประเภทผู้ใช้งาน
      role_id: "", // บทบาท (uid)
      supervisor_id: "", // ผู้บังคับบัญชา (uid)
      department_access: [], // สิทธิ์เข้าถึงตามแผนก (array ของ department uid)
      dept_dropdown_open: false, // เปิด/ปิด dropdown สิทธิ์เข้าถึงแผนก
      dept_search: "", // ค้นหาแผนกใน dropdown

      // ลายเซ็น (ส่วนที่ 6) — มีได้แค่ 1 ลายเซ็น
      signature: "", // URL ไฟล์ลายเซ็นที่อัปโหลดแล้ว
      signature_edit_mode: false // เปิดกระดานวาดลายเซ็น
    };

    this.signatureCanvasRef = React.createRef();
    // input file ที่ซ่อนไว้สำหรับปุ่ม "อัปโหลดลายเซ็น" (ISS-033) - ใช้ร่วมกันทุกปุ่มในส่วนลายเซ็น
    this.signatureFileRef = React.createRef();
    this.isDrawingSignature = false;
    this.hasSignatureStroke = false;
  }

  // สถานะช่างเหลือ 2 ค่า: active / inactive — ค่าเก่า resigned/suspended ถือเป็น inactive
  normalizeStatus = (item) => {
    const status = String(item?.status || "").trim().toLowerCase();
    if (status === "active") return "active";
    if (["inactive", "resigned", "suspended"].includes(status)) return "inactive";
    return item?.is_active === false ? "inactive" : "active";
  };

  async componentDidMount() {
    loading(false);
    this.Get(1);
  }

  // -----------------------------------
  // API Methods
  // -----------------------------------
  Get = async (page) => {
    loading(true);
    let data, count, data_skill = [];
    let data_departments = [], data_roles = [], data_supervisors = [];
    let [result, result_models, result_departments, result_roles, result_supervisors] = await Promise.all([
       GET("admin/technicians", {
        page_size: this.state.page_size,
        page: page,
        data_search: this.state.filter_search || "",
        status: this.state.filter_status || ""
    }),
    GET("warehouse/models", {
              page_size: 100000,
              page: 0,
            }),
    GET("admin/departments", { page_size: 1000, page: 0 }),
    GET("admin/roles", { page_size: 1000, page: 0 }),
    // ผู้บริหารเลือกเป็นผู้บังคับบัญชาได้เช่นเดียวกับ supervisor
    GET("admin/users", { page_size: 1000, page: 0, user_type: "supervisor,executive" })
    ]);

    if (result?.status) {

        data= result.data || []
        count= result.pagination?.count || 0
    }
    if (result_models?.status) {
      // ความชำนาญเครื่องพิมพ์ อิงจากข้อมูล "models" (รุ่นเครื่องพิมพ์) แทนยี่ห้อ (brands)
      data_skill = result_models.data || [];
    }
    if (result_departments?.status) data_departments = result_departments.data || [];
    if (result_roles?.status) data_roles = result_roles.data || [];
    if (result_supervisors?.status) data_supervisors = result_supervisors.data || [];

    this.setState({ data, count, page, data_skill, data_departments, data_roles, data_supervisors });
    loading(false);
  };

  GetById = async (uid) => {
    loading(true);
    let result = await GET("admin/technicians", { 
        uid: uid,
    });

    if (result?.status) {
      this.setState({ 
        ...result.data
      });
    }
    loading(false);
  };


  CreateUpdate = async () => {
    const {
      uid, emp_id, title_th, fname_th, lname_th, nickname_th, status, company_id,
      title_en, fname_en, lname_en, nickname_en, phone, email, bank, account_no, account_name,
      has_car, has_motorcycle, printers,
      password, has_login_user, department_id, role_id, supervisor_id, department_access,
      signature
    } = this.state;

    // Basic Validation — ตรวจ field ที่มี * ให้ครบ
    if (
      !fname_th.trim() || !lname_th.trim() ||          // ส่วนที่ 1
      !phone.trim() || !email.trim() ||                 // ส่วนที่ 2
      !department_id || !role_id ||                     // ส่วนที่ 3
      (!has_login_user && !password.trim()) ||          // ส่วนที่ 3 — รหัสผ่านบังคับเมื่อยังไม่มี user (สร้างใหม่/ยังไม่เคยมี login)
      !bank.trim() || !account_no.trim() || !account_name.trim() // ส่วนที่ 4
    ) {
      alert("", "warning", t("warning"), t("required_fields_missing"));
      return;
    }

    if (await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel"))) {
      loading(true);
      
      // Map name สำหรับธนาคาร
      const bankNames = { "SCB": "ธนาคารไทยพาณิชย์", "KBANK": "ธนาคารกสิกรไทย", "BBL": "ธนาคารกรุงเทพ" };

      // Map ลำดับ sequence สำหรับ skills
      let technician_skill = printers.map((p, index) => ({
        sequence: index + 1,
        item: p.name || p.item,
        level: p.level,
        is_active: true
      }));

      let body = {
        company_id: company_id,
        technician_code: emp_id,
        perfix_name: title_th,
        perfix_name_en: title_en,
        first_name_th: fname_th,
        last_name_th: lname_th,
        first_name_en: fname_en,
        last_name_en: lname_en,
        nickname_th: nickname_th,
        nickname_en: nickname_en,
        image: "", // ว่างไว้ตาม cURL
        status: status === "inactive" ? "inactive" : "active",
        phone: phone,
        email: email,
        bank_name: bankNames[bank] || bank,
        bank_code: bank,
        bank_account_number: account_no,
        bank_account_name: account_name || `${fname_th} ${lname_th}`, // อัตโนมัติตามชื่อ-สกุล
        is_car: has_car,
        is_motorcycle: has_motorcycle,
        is_active: status === "active",
        technician_skill: technician_skill,
        signature: signature || "-", // "-" กันไม่ให้ removeEmptyString() ใน PUT/POST ตัดคีย์นี้ทิ้งตอนลบลายเซ็น (ค่า "-" จะถูกแปลงกลับเป็น "" ก่อนส่งจริง)

        // สิทธิ์การใช้งานระบบ (ใช้สร้าง user สำหรับ login) — backend default user_type = technician
        user_type: "technician",
        role_id: role_id,
        department_id: department_id,
        supervisor_id: supervisor_id || "",
        department_access: department_access,
        ...(password.trim() ? { password: password } : {}) // ส่ง password เฉพาะเมื่อกรอก (update เว้นว่างได้)
      };

      let result = !uid
        ? await POST("admin/technicians", body)
        : await PUT("admin/technicians/" + uid, body);

      if (result?.status === true) {
        alert("#", "success");
        this.setState({ modal_create: false, modal_update: false });
        this.resetForm();
        this.Get(this.state.page);
      } else {
        alert("", "warning", t("warning"), result?.message || "An error occurred.");
      }
      loading(false);
    }
  };

  Delete = async (id) => {
    if (await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel"))) {
      loading(true);
      let result = await DELETE("admin/technicians/" + id, null);
      if (result?.status) {
        alert("#", "success");
        this.setState({ modal_update: false });
        this.Get(1); 
      } else {
        alert("", "warning", t("warning"), result?.message || "An error occurred.");
      }
      loading(false);
    }
  };

  // -----------------------------------
  // Helpers & Form Management
  // -----------------------------------
  Edit = async (item) => {
    loading(true);
    // ดึงข้อมูลแบบรายตัว เพื่อให้ได้ข้อมูล user (role/department/supervisor/department_access) ครบ
    let result = await GET("admin/technicians", { uid: item.uid });
    const data = result?.status && result.data ? result.data : item;

    this.setState({
      modal_update: true,
      uid: data.uid,
      emp_id: data.technician_code || "",
      title_th: data.perfix_name || "นาย",
      fname_th: data.first_name_th || "",
      lname_th: data.last_name_th || "",
      nickname_th: data.nickname_th || "",
      status: this.normalizeStatus(data),
      title_en: data.perfix_name_en || "Mr.",
      fname_en: data.first_name_en || "",
      lname_en: data.last_name_en || "",
      nickname_en: data.nickname_en || "",
      phone: data.phone || "",
      email: data.email || "",
      bank: data.bank_code || "SCB",
      account_no: data.bank_account_number || "",
      account_name: data.bank_account_name || "",
      has_car: data.is_car || false,
      has_motorcycle: data.is_motorcycle || false,
      printers: (data.technician_skill || []).map(skill => ({
        id: skill.uid || Date.now() + Math.random(),
        name: skill.item,
        level: skill.level || "ชำนาญ"
      })).sort((a, b) => a.sequence - b.sequence),
      // สิทธิ์การใช้งานระบบ — map จากข้อมูล user ที่ผูกไว้ (password เว้นว่าง = ไม่เปลี่ยน)
      password: "", show_password: false,
      has_login_user: !!data.user_id, // มี user แล้ว → ซ่อน input password
      role_id: data.role_id || "",
      department_id: data.department_id || "",
      supervisor_id: data.supervisor_id || "",
      user_type: data.user_type || "technician",
      department_access: data.department_access || [],
      signature: data.signature || "",
      signature_edit_mode: false,
    });
    loading(false);
  };

  resetForm = () => {
    this.setState({
      uid: "", emp_id: "", title_th: "นาย", fname_th: "", lname_th: "", nickname_th: "", status: "active",
      title_en: "Mr.", fname_en: "", lname_en: "", nickname_en: "", phone: "", email: "", bank: "SCB", account_no: "", account_name: "",
      has_car: false, has_motorcycle: false, printers: [], new_printer_select: "",
      password: "", show_password: false, has_login_user: false, department_id: "", user_type: "technician",
      role_id: "", supervisor_id: "", department_access: [],
      signature: "", signature_edit_mode: false
    });
    this.hasSignatureStroke = false;
  };

  // --- Department Access Management (สิทธิ์เข้าถึงตามแผนก) ---
  setHomeDepartment = (uid) => {
    // แผนกต้นสังกัดถูก lock เข้าใน department_access เสมอ
    this.setState((prev) => {
      const access = prev.department_access.filter((d) => d !== prev.department_id); // ถอดแผนกเดิมที่ lock ออกก่อน
      if (uid && !access.includes(uid)) access.push(uid);
      return { department_id: uid, department_access: access };
    });
  };

  toggleDepartmentAccess = (uid) => {
    if (uid === this.state.department_id) return; // แผนกต้นสังกัด lock ไว้ ลบไม่ได้
    this.setState((prev) => ({
      department_access: prev.department_access.includes(uid)
        ? prev.department_access.filter((d) => d !== uid)
        : [...prev.department_access, uid],
    }));
  };

  toggleSelectAllDepartments = () => {
    this.setState((prev) => {
      const allUids = prev.data_departments.map((d) => d.uid);
      const allSelected = allUids.length > 0 && allUids.every((u) => prev.department_access.includes(u));
      // ถ้าเลือกครบแล้ว → ล้างทั้งหมด (ยกเว้นแผนกต้นสังกัดที่ lock ไว้) / ไม่ครบ → เลือกทั้งหมด
      return {
        department_access: allSelected
          ? (prev.department_id ? [prev.department_id] : [])
          : allUids,
      };
    });
  };

  openCreateModal = () => {
    this.resetForm();
    this.setState({ modal_create: true });
  }

  // --- Printer Management ---
  handleAddPrinter = () => {
    if(!this.state.new_printer_select) return;
    const newPrinter = {
      id: Date.now(),
      name: this.state.new_printer_select,
      level: "ชำนาญ"
    };
    this.setState({ 
      printers: [...this.state.printers, newPrinter],
      new_printer_select: ""
    });
  }

  handleRemovePrinter = (id) => {
    this.setState({ printers: this.state.printers.filter(p => p.id !== id) });
  }

  handleUpdatePrinterLevel = (id, level) => {
    let newPrinters = this.state.printers.map(p => p.id === id ? { ...p, level: level } : p);
    this.setState({ printers: newPrinters });
  }

  movePrinter = (index, direction) => {
    let newPrinters = [...this.state.printers];
    if (direction === 'up' && index > 0) {
      [newPrinters[index-1], newPrinters[index]] = [newPrinters[index], newPrinters[index-1]];
    } else if (direction === 'down' && index < newPrinters.length - 1) {
      [newPrinters[index+1], newPrinters[index]] = [newPrinters[index], newPrinters[index+1]];
    }
    this.setState({ printers: newPrinters });
  }

  // --- Signature Management (ส่วนที่ 6 — มีได้แค่ 1 ลายเซ็น) ---
  openSignaturePad = () => {
    this.hasSignatureStroke = false;
    this.setState({ signature_edit_mode: true }, () => {
      const canvas = this.signatureCanvasRef.current;
      if (!canvas) return;
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.lineWidth = 2;
      ctx.lineCap = "round";
      ctx.strokeStyle = "#1B2559";
    });
  };

  cancelSignatureEdit = () => {
    this.hasSignatureStroke = false;
    this.setState({ signature_edit_mode: false });
  };

  getSignaturePoint = (e) => {
    const canvas = this.signatureCanvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const touch = e.touches && e.touches[0];
    const clientX = touch ? touch.clientX : e.clientX;
    const clientY = touch ? touch.clientY : e.clientY;
    return {
      x: (clientX - rect.left) * (canvas.width / rect.width),
      y: (clientY - rect.top) * (canvas.height / rect.height),
    };
  };

  handleSignatureStart = (e) => {
    e.preventDefault();
    this.isDrawingSignature = true;
    this.hasSignatureStroke = true;
    const { x, y } = this.getSignaturePoint(e);
    const ctx = this.signatureCanvasRef.current.getContext("2d");
    ctx.beginPath();
    ctx.moveTo(x, y);
  };

  handleSignatureMove = (e) => {
    if (!this.isDrawingSignature) return;
    e.preventDefault();
    const { x, y } = this.getSignaturePoint(e);
    const ctx = this.signatureCanvasRef.current.getContext("2d");
    ctx.lineTo(x, y);
    ctx.stroke();
  };

  handleSignatureEnd = () => {
    this.isDrawingSignature = false;
  };

  clearSignaturePad = () => {
    const canvas = this.signatureCanvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    this.hasSignatureStroke = false;
  };

  saveSignature = async () => {
    if (!this.hasSignatureStroke) {
      alert("", "warning", t("warning"), t("signature_required_hint"));
      return;
    }
    const canvas = this.signatureCanvasRef.current;
    loading(true);
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/png"));
    const file = new File([blob], `signature_${Date.now()}.png`, { type: "image/png" });
    // ลายเซ็นส่วนใหญ่เล็กกว่าเกณฑ์อยู่แล้ว จึงมักถูกข้ามไป แต่กันเคส canvas ใหญ่ผิดปกติ
    const compressed = await compressImageFile(file);
    const res = await UPLOAD(compressed, { folder: "technicians/signatures" });

    if (res?.status === true && res?.data?.file_path) {
      this.hasSignatureStroke = false;
      this.setState({ signature: res.data.file_path, signature_edit_mode: false });
    } else {
      alert("", "warning", t("warning"), `${t("upload")} ${t("fail")}`);
    }
    loading(false);
  };

  // อัปโหลดไฟล์ลายเซ็นที่ช่างมีอยู่แล้ว (ISS-033) - เพดาน 2MB และรับเฉพาะไฟล์รูป เหมือนฝั่งแอปมือถือ
  handleSignatureFile = async (e) => {
    const file = e.target.files?.[0];
    // ล้างค่า input ทันที ไม่งั้นเลือกไฟล์เดิมซ้ำอีกครั้งจะไม่เกิด event
    e.target.value = "";
    if (!file) return;

    if (!file.type?.startsWith("image/")) {
      alert("", "warning", t("warning"), t("signature_image_only"));
      return;
    }

    if (file.size > SIGNATURE_MAX_SIZE) {
      alert("", "warning", t("warning"), t("signature_too_large"));
      return;
    }

    loading(true);
    // ลายเซ็นส่วนใหญ่เล็กอยู่แล้ว compressImageFile จะข้ามให้เอง (ดู IMAGE_SKIP_COMPRESS_BELOW)
    const compressed = await compressImageFile(file);
    const res = await UPLOAD(compressed, { folder: "technicians/signatures" });

    if (res?.status === true && res?.data?.file_path) {
      this.hasSignatureStroke = false;
      this.setState({ signature: res.data.file_path, signature_edit_mode: false });
    } else {
      alert("", "warning", t("warning"), `${t("upload")} ${t("fail")}`);
    }
    loading(false);
  };

  openSignatureFilePicker = () => this.signatureFileRef.current?.click();

  removeSignature = async () => {
    if (await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel"))) {
      this.setState({ signature: "", signature_edit_mode: false });
    }
  };

  // --- Display Formatters ---
  getInitials = (fname, lname) => {
    let first = fname ? fname.charAt(0) : "";
    let last = lname ? lname.charAt(0) : "";
    return (first + last).toUpperCase() || "NA";
  }

  getStatusBadge = (item) => {
    switch (this.normalizeStatus(item)) {
      case "active": return { label: t("active_with_en"), color: "success", border: "#198754" };
      case "inactive": return { label: t("technician_status_inactive"), color: "secondary", border: "#6c757d" };
      default: return { label: t("unknown"), color: "primary", border: "#0d6efd" };
    }
  }

  formatBankAcct = (acc) => {
    if(!acc) return 'XXX-XXXX-XXX';
    return acc.replace(/(\d{3})(\d{1})(\d{5})(\d{1})/, '$1-$2-$3-$4');
  }

  render() {
    const {
      data, count, data_skill, page, filter_search, filter_status,
      data_departments, data_roles, data_supervisors,
      modal_create, modal_update, uid, emp_id, title_th, fname_th, lname_th, nickname_th, status,
      title_en, fname_en, lname_en, nickname_en, phone, email, bank, account_no, account_name, has_car, has_motorcycle, printers,
      password, show_password, has_login_user, department_id, role_id, supervisor_id, department_access,
      dept_dropdown_open, dept_search, signature, signature_edit_mode
    } = this.state;

    // คำนวณสถิติ
    const totalCount = count;
    const activeCount = data.filter(d => this.normalizeStatus(d) === 'active').length;
    const inactiveCount = totalCount - activeCount;

    return (
        <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
            <NavbarAdmin />
            <div className="body p-4 mt-3">
                {/* Header Section */}
                <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
                    <div>
                        <h3 className="fw-bold mb-1 text-dark">{t("technicians")}</h3>
                        <div className="text-secondary text-14">{t("manage_technician_desc")}</div>
                    </div>
                    <div className="d-flex gap-2">
                        {can("technicians.create") && (
                          <button className="btn btn-primary px-3 py-2 fw-bold rounded-3 shadow-sm d-flex align-items-center" onClick={this.openCreateModal}>
                              <span className="me-2 text-16">+</span> {t("add_technician")}
                          </button>
                        )}
                    </div>
                </div>

                {/* Top KPI Cards */}
                <div className="row g-3 mb-4">
                    <div className="col-lg-3 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                            <div className="d-flex align-items-center justify-content-between">
                                <div>
                                    <div className="text-secondary text-12 mb-1">{t("total_technicians")}</div>
                                    <h4 className="fw-bold text-dark mb-0">{totalCount}</h4>
                                </div>
                                <div className="wpx-40 hpx-40 rounded bg-primary-light text-primary d-flex align-items-center justify-content-center text-18 icon">{"\uf0c0"}</div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                            <div className="d-flex align-items-center justify-content-between">
                                <div>
                                    <div className="text-secondary text-12 mb-1">{t("active_now")}</div>
                                    <h4 className="fw-bold text-success mb-0">{activeCount}</h4>
                                </div>
                                <div className="wpx-40 hpx-40 rounded bg-success-light text-success d-flex align-items-center justify-content-center text-18 icon">{"\uf4fc"}</div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                            <div className="d-flex align-items-center justify-content-between">
                                <div>
                                    <div className="text-secondary text-12 mb-1">{t("kpi_other_status")}</div>
                                    <h4 className="fw-bold text-secondary mb-0">{inactiveCount}</h4>
                                </div>
                                <div className="wpx-40 hpx-40 rounded bg-light text-secondary border d-flex align-items-center justify-content-center text-18 icon">{"\uf073"}</div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Search Box */}
                <div className="d-flex flex-wrap align-items-center mb-4">
                    <div className="position-relative" style={{ maxWidth: "300px", width: "100%" }}>
                        <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">{"\uf002"}</span>
                        <input
                            type="text"
                            className="form-control ps-5 wpx-300 rounded-3 border-0 shadow-sm"
                            placeholder={t("search_technician_placeholder")}
                            value={filter_search}
                            onChange={(e) => this.setState({ filter_search: e.target.value })}
                            onKeyDown={(e) => e.key === "Enter" && this.Get(1)}
                        />
                    </div>
                    <select className="form-select wpx-150 ms-2 rounded-3 border-0 shadow-sm" value={filter_status} onChange={(e) => this.setState({ filter_status: e.target.value }, () => this.Get(1))}>
                        <option value="">{t("all_status")}</option>
                        <option value="active">{t("active_with_en")}</option>
                        <option value="inactive">{t("technician_status_inactive")}</option>
                    </select>
                    <button className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm ms-2" onClick={() => this.Get(1)}>
                        {t("filter")}
                    </button>
                    <button className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm ms-2" onClick={() => this.setState({ filter_search: "", filter_status: "" }, () => this.Get(1))}>
                        {t("clear_all")}
                    </button>
                </div>

                {/* Grid Layout for Technician Cards */}
                <div className="row g-4">
                    {data.length > 0 ? (
                        data.map((item, idx) => {
                            let badge = this.getStatusBadge(item);

                            return (
                                <div key={idx} className="col-lg-4 col-md-6">
                                    <div
                                        className="card border-0 rounded-4 shadow-sm p-4 h-100 bg-white pointer transition-hover"
                                        style={{ borderTop: `4px solid ${badge.border}` }}
                                        onClick={() => this.Edit(item)}
                                    >
                                        <div className="d-flex justify-content-between align-items-start mb-4">
                                            <div className="d-flex align-items-center">
                                                <div
                                                    className={`wpx-50 hpx-50 rounded-circle text-white d-flex align-items-center justify-content-center fw-bold text-20 me-3 flex-shrink-0 bg-${badge.color}`}
                                                >
                                                    {this.getInitials(item.first_name_th, item.last_name_th)}
                                                </div>
                                                <div>
                                                    <h6 className="fw-bold text-dark mb-1">
                                                        {item.first_name_th} {item.last_name_th}
                                                    </h6>
                                                    <div className="text-secondary text-12 mb-1">{item.technician_code || "-"}</div>
                                                    <span className={`badge bg-${badge.color}-light text-${badge.color} rounded-1 px-2 py-1 text-10 fw-bold`}>{badge.label}</span>
                                                </div>
                                            </div>
                                            <span className="icon text-secondary pointer text-14">{"\uf142"}</span>
                                        </div>

                                        <div className="d-flex flex-column gap-2 mb-3 border-bottom pb-4">
                                            <div className="text-secondary text-14 d-flex align-items-center">
                                                <span className="icon me-2 wpx-15 text-center">{"\uf095"}</span> {item.phone || "-"}
                                            </div>
                                            <div className="text-secondary text-14 d-flex align-items-center">
                                                <span className="icon me-2 wpx-15 text-center">{"\uf0e0"}</span> {item.email || "-"}
                                            </div>
                                            <small>{t("skills")}</small>
                                            {/* แสดงทักษะเบื้องต้น (3 อันดับแรก) */}
                                            <div className="d-flex flex-wrap gap-2">
                                                {(item.technician_skill || [])
                                                    .sort((a, b) => a.sequence - b.sequence)
                                                    .slice(0, 3)
                                                    .map((skill, sIdx) => (
                                                        <span key={sIdx} className="badge bg-light text-dark border px-2 py-1 text-10 fw-medium">
                                                            {data_skill.find((s) => s.uid === skill.item)?.name || skill.item || t("unknown_skill")}
                                                        </span>
                                                    ))}
                                                {item.technician_skill?.length > 3 && (
                                                    <span className="badge bg-light text-secondary border px-2 py-1 text-10 fw-medium">+{item.technician_skill.length - 3}</span>
                                                )}
                                            </div>
                                        </div>
                                        <small>{t("today_jobs")}</small>
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <div className="col-12 text-center py-5 text-secondary">{t("no_technicians_found")}</div>
                    )}
                </div>

                <div className="d-flex justify-content-end align-items-center mt-4">
                    <Pagination count={Math.ceil(count / this.state.page_size) || 1} page={page} onChange={(_, p) => this.Get(p)} showFirstButton={false} showLastButton={false} />
                </div>
            </div>

            {/* ======================================= */}
            {/* MODAL CREATE / UPDATE TECHNICIAN        */}
            {/* ======================================= */}
            <Modal
                size="xl"
                show={modal_create || modal_update}
                onHide={() => this.setState({ modal_create: false, modal_update: false })}
                centered
                // backdrop="static"
            >
                {/* Header */}
                <div className="modal-header border-bottom bg-white d-flex justify-content-between align-items-center py-3 px-4">
                    <div className="d-flex align-items-center">
                        <span className="icon text-primary text-24 me-2">{"\uf82f"}</span>
                        <h4 className="fw-bold mb-0 text-dark" style={{ color: "#2B3674" }}>
                            {t("save_employee_data_title")}
                        </h4>
                        <span className="text-primary mx-2">•</span>
                        <span className="text-primary fw-medium text-14">{modal_create ? t("create_new") : t("edit_data")}</span>
                    </div>
                    <button type="button" className="btn-close" onClick={() => this.setState({ modal_create: false, modal_update: false })}></button>
                </div>

                <Modal.Body className="p-4" style={{ backgroundColor: "#F4F7FE" }}>
                    {/* Profile Summary Header */}
                    <div className="d-flex align-items-center bg-white p-3 rounded-4 shadow-sm mb-4 border">
                        <div className="position-relative me-4 ms-2">
                            <div className="bg-light border rounded-circle d-flex align-items-center justify-content-center text-secondary" style={{ width: 70, height: 70 }}>
                                <span className="icon text-24">{"\uf007"}</span>
                            </div>
                        </div>
                        <div>
                            <h4 className="fw-bold mb-1" style={{ color: "#2B3674" }}>
                                {emp_id || "XXXX-XXXXXXX"}
                            </h4>
                            <div className="text-secondary text-14 mb-2">{fname_th ? `${fname_th} ${lname_th}` : t("name_placeholder_hint")}</div>
                            <span className="badge bg-info-light text-info border border-info px-2 py-1">{t("company_staff")}</span>
                            <span className="badge bg-warning-light text-warning border border-warning px-2 py-1 ms-2">
                                {data_roles.find((r) => r.uid === role_id)?.name || t("role_placeholder_dash")}
                            </span>
                        </div>
                    </div>

                    {/* ส่วนที่ 1: ข้อมูลส่วนตัว */}
                    <div className="card border shadow-sm rounded-4 mb-4">
                        <div className="card-body p-4">
                            <h6 className="fw-bold text-dark mb-4 pb-2 border-bottom" style={{ color: "#2B3674" }}>
                                <span className="text-primary me-2">•</span>
                                {t("section_personal_info")}
                            </h6>
                            {/* ข้อมูลทั่วไป */}
                            <div className="row g-3 mb-4">
                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("employee_code")}</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={t("auto_generate_hint")}
                                        value={emp_id}
                                        onChange={(e) => this.setState({ emp_id: e.target.value })}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">
                                        {t("status")} <span className="text-danger">*</span>
                                    </label>
                                    <div className="d-flex gap-4 align-items-center" style={{ minHeight: 38 }}>
                                        <div className="form-check d-flex align-items-center gap-2">
                                            <input
                                                className="form-check-input mt-0 pointer"
                                                type="radio"
                                                name="technicianStatus"
                                                id="technicianStatusActive"
                                                checked={status !== "inactive"}
                                                onChange={() => this.setState({ status: "active" })}
                                            />
                                            <label className="form-check-label text-dark text-14 pointer" htmlFor="technicianStatusActive">
                                                {t("active_with_en")}
                                            </label>
                                        </div>
                                        <div className="form-check d-flex align-items-center gap-2">
                                            <input
                                                className="form-check-input mt-0 pointer"
                                                type="radio"
                                                name="technicianStatus"
                                                id="technicianStatusInactive"
                                                checked={status === "inactive"}
                                                onChange={() => this.setState({ status: "inactive" })}
                                            />
                                            <label className="form-check-label text-dark text-14 pointer" htmlFor="technicianStatusInactive">
                                                {t("technician_status_inactive")}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* ภาษาไทย */}
                            <div className="p-3 rounded-3 mb-3" style={{ backgroundColor: "#F8FAFD", border: "1px solid #E0E5F2" }}>
                                <div className="mb-3">
                                    <span className="icon text-primary me-2 text-12">{"\uf1ab"}</span>
                                    <span className="fw-bold text-14 text-dark">{t("thai_info_section")}</span>
                                </div>
                                <div className="row g-3">
                                    <div className="col-md-2">
                                        <label className="form-label text-12 fw-bold text-secondary mb-1">{t("prefix")}</label>
                                        <select className="form-select" value={title_th} onChange={(e) => this.setState({ title_th: e.target.value })}>
                                            <option value="นาย">นาย</option>
                                            <option value="นาง">นาง</option>
                                            <option value="นางสาว">นางสาว</option>
                                        </select>
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label text-12 fw-bold text-secondary mb-1">
                                            {t("first_name_th_label")} <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder={t("firstname_th_placeholder")}
                                            value={fname_th}
                                            onChange={(e) => this.setState({ fname_th: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <label className="form-label text-12 fw-bold text-secondary mb-1">
                                            {t("last_name_th_label")} <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder={t("lastname_th_placeholder")}
                                            value={lname_th}
                                            onChange={(e) => this.setState({ lname_th: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <label className="form-label text-12 fw-bold text-secondary mb-1">{t("nickname_th_label")}</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder={t("nickname_th_placeholder")}
                                            value={nickname_th}
                                            onChange={(e) => this.setState({ nickname_th: e.target.value })}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* ภาษาอังกฤษ */}
                            <div className="p-3 rounded-3" style={{ backgroundColor: "#F8FAFD", border: "1px solid #E0E5F2" }}>
                                <div className="mb-3">
                                    <span className="icon text-info me-2 text-12">{"\uf0ac"}</span>
                                    <span className="fw-bold text-14 text-dark">{t("english_info_section")}</span>
                                </div>
                                <div className="row g-3">
                                    <div className="col-md-2">
                                        <label className="form-label text-12 fw-bold text-secondary mb-1">{t("prefix")}</label>
                                        <select className="form-select" value={title_en} onChange={(e) => this.setState({ title_en: e.target.value })}>
                                            <option value="นาย">Mr.</option>
                                            <option value="นาง">Mrs.</option>
                                            <option value="นางสาว">Miss</option>
                                        </select>
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label text-12 fw-bold text-secondary mb-1">{t("first_name_en_label")}</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder={t("firstname_en_placeholder")}
                                            value={fname_en}
                                            onChange={(e) => this.setState({ fname_en: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <label className="form-label text-12 fw-bold text-secondary mb-1">{t("last_name_en_label")}</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder={t("lastname_en_placeholder")}
                                            value={lname_en}
                                            onChange={(e) => this.setState({ lname_en: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <label className="form-label text-12 fw-bold text-secondary mb-1">{t("nickname_en_label")}</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder={t("nickname_en_placeholder")}
                                            value={nickname_en}
                                            onChange={(e) => this.setState({ nickname_en: e.target.value })}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ส่วนที่ 2: ข้อมูลการติดต่อ */}
                    <div className="card border shadow-sm rounded-4 mb-4">
                        <div className="card-body p-4">
                            <h6 className="fw-bold text-dark mb-4 pb-2 border-bottom" style={{ color: "#2B3674" }}>
                                <span className="text-primary me-2">•</span>
                                {t("section_contact_info")}
                            </h6>
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">
                                        {t("phone")} <span className="text-danger">*</span>
                                    </label>
                                    <input type="text" className="form-control" placeholder={t("phone_placeholder_example")} value={phone} onChange={(e) => this.setState({ phone: e.target.value })} />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">
                                        {t("email")} <span className="text-danger">*</span>
                                    </label>
                                    <input type="email" className="form-control" placeholder="email@domain.com" value={email} onChange={(e) => this.setState({ email: e.target.value })} />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ส่วนที่ 3: สิทธิ์การใช้งานระบบ */}
                    <div className="card border shadow-sm rounded-4 mb-4">
                        <div className="card-body p-4">
                            <h6 className="fw-bold text-dark mb-4 pb-2 border-bottom" style={{ color: "#2B3674" }}>
                                <span className="text-primary me-2">•</span>
                                {t("section_user_authorization")}
                            </h6>

                            {/* ข้อมูลการเข้าสู่ระบบ */}
                            <div className="mb-2">
                                <span className="icon text-warning me-2 text-14">{"\uf084"}</span>
                                <span className="fw-bold text-14 text-dark">{t("login_info_section")}</span>
                            </div>
                            <div className="text-warning rounded-3 text-12 mb-3 d-flex align-items-center">
                                <span className="icon me-2">{"\uf05a"}</span> {t("login_email_hint")}
                            </div>
                            <div className="row g-3 mb-4">
                                <div className="col-md-6">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">
                                        {t("password")} {!has_login_user && <span className="text-danger">*</span>}
                                    </label>
                                    {has_login_user ? (
                                        <div className="d-flex align-items-center bg-light border rounded-3 px-3 text-secondary text-12" style={{ height: "38px" }}>
                                            <span className="icon me-2">{"\uf023"}</span> {t("already_has_password")}
                                        </div>
                                    ) : (
                                        <div className="position-relative">
                                            <input
                                                type={show_password ? "text" : "password"}
                                                className="form-control"
                                                style={{ paddingRight: "2.5rem" }}
                                                placeholder={t("password_initial_placeholder")}
                                                value={password}
                                                onChange={(e) => this.setState({ password: e.target.value })}
                                            />
                                            <span
                                                className="icon text-secondary cursor-pointer position-absolute"
                                                style={{ right: "0.9rem", top: "50%", transform: "translateY(-50%)" }}
                                                onClick={() => this.setState({ show_password: !show_password })}
                                            >
                                                {show_password ? "\uf070" : "\uf06e"}
                                            </span>
                                        </div>
                                    )}
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">
                                        {t("home_department_label")} <span className="text-danger">*</span>
                                    </label>
                                    <Select
                                        className="form-control"
                                        placeholder={t("select_department_placeholder")}
                                        value={department_id}
                                        options={activeOptions(data_departments.map((d) => ({ is_active: d.is_active, value: d.uid, label: d.name })), department_id)}
                                        onChange={(value) => this.setHomeDepartment(value)}
                                    />
                                </div>
                            </div>

                            {/* กำหนดบทบาท */}
                            <div className="mb-2">
                                <span className="icon text-secondary me-2 text-14">{"\uf02b"}</span>
                                <span className="fw-bold text-14 text-dark">{t("assign_role_section")}</span>
                            </div>
                            <div className="row g-3 mb-2">
                                <div className="col-md-6">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">
                                        {t("role_with_label")} <span className="text-danger">*</span>
                                    </label>
                                    <Select
                                        className="form-control"
                                        placeholder={t("select_role_placeholder")}
                                        value={role_id}
                                        options={activeOptions(data_roles.map((r) => ({ is_active: r.is_active, value: r.uid, label: r.name })), role_id)}
                                        onChange={(value) => this.setState({ role_id: value })}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("supervisor")}</label>
                                    <Select
                                        className="form-control"
                                        placeholder={t("select_supervisor_placeholder")}
                                        value={supervisor_id}
                                        options={activeOptions(data_supervisors.map((s) => ({ is_active: s.is_active, value: s.uid, label: s.full_name })), supervisor_id)}
                                        onChange={(value) => this.setState({ supervisor_id: value })}
                                    />
                                </div>
                            </div>

                            {/* สิทธิ์การเข้าถึงตามแผนก */}
                            <div className="mb-2 mt-4">
                                <span className="icon text-secondary me-2 text-14">{"\uf1ad"}</span>
                                <span className="fw-bold text-14 text-dark">{t("department_access")}</span>
                            </div>
                            <div className="text-warning rounded-3 text-12 mb-3 d-flex align-items-center">
                                <span className="icon me-2">{"\uf05a"}</span> {t("department_access_desc")}
                            </div>
                            <div className="position-relative">
                                <div
                                    className={`border rounded-3 p-2 d-flex align-items-center bg-white ${dept_dropdown_open ? "border-primary" : ""}`}
                                    style={{ minHeight: "48px", cursor: "pointer" }}
                                    onClick={() => this.setState({ dept_dropdown_open: !dept_dropdown_open })}
                                >
                                    <div className="d-flex flex-wrap gap-2 align-items-center flex-grow-1">
                                        {department_access.length === 0 && <span className="text-secondary text-12 px-2">{t("department_access_empty")}</span>}
                                        {department_access.map((depUid) => {
                                            const dep = data_departments.find((d) => d.uid === depUid);
                                            const locked = depUid === department_id;
                                            return (
                                                <span key={depUid} className="badge bg-primary-light text-primary border border-primary px-2 py-2 fw-medium text-12 d-inline-flex align-items-center">
                                                    {dep?.department_code || dep?.name || depUid}
                                                    {locked ? (
                                                        <span className="icon ms-2 text-12">{"\uf023"}</span>
                                                    ) : (
                                                        <span
                                                            className="icon ms-2 text-12 cursor-pointer text-danger"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                this.toggleDepartmentAccess(depUid);
                                                            }}
                                                        >
                                                            {"\uf00d"}
                                                        </span>
                                                    )}
                                                </span>
                                            );
                                        })}
                                    </div>
                                    <span className="icon text-secondary ms-2">{dept_dropdown_open ? "\uf077" : "\uf078"}</span>
                                </div>

                                {dept_dropdown_open && (
                                    <>
                                        <div className="position-fixed" style={{ inset: 0, zIndex: 1040 }} onClick={() => this.setState({ dept_dropdown_open: false, dept_search: "" })} />
                                        <div className="position-absolute bg-white border rounded-3 shadow w-100 mt-1 p-2" style={{ zIndex: 1050, maxHeight: "320px", overflowY: "auto" }}>
                                            <input
                                                type="text"
                                                className="form-control mb-2"
                                                placeholder={t("search")}
                                                value={dept_search}
                                                onChange={(e) => this.setState({ dept_search: e.target.value })}
                                            />
                                            <label className="d-flex align-items-center gap-2 px-2 py-2 border-bottom fw-bold text-dark mb-1" style={{ cursor: "pointer" }}>
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input mt-0"
                                                    checked={data_departments.length > 0 && data_departments.every((d) => department_access.includes(d.uid))}
                                                    onChange={this.toggleSelectAllDepartments}
                                                />
                                                {t("department_access_select_all")}
                                            </label>
                                            {data_departments
                                                .filter((d) => !dept_search || (d.name || "").includes(dept_search) || (d.department_code || "").includes(dept_search))
                                                .map((d) => {
                                                    const checked = department_access.includes(d.uid);
                                                    const locked = d.uid === department_id;
                                                    return (
                                                        <label
                                                            key={d.uid}
                                                            className="d-flex align-items-center gap-2 px-2 py-2 rounded-2 hover-bg-light"
                                                            style={{ cursor: locked ? "not-allowed" : "pointer" }}
                                                        >
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input mt-0"
                                                                checked={checked}
                                                                disabled={locked}
                                                                onChange={() => this.toggleDepartmentAccess(d.uid)}
                                                            />
                                                            <span className="badge bg-primary-light text-primary border border-primary px-2 py-1 text-12">{d.department_code || "-"}</span>
                                                            <span className="text-14 text-dark">{d.name}</span>
                                                            {locked && <span className="icon ms-auto text-secondary text-12">{"\uf023"}</span>}
                                                        </label>
                                                    );
                                                })}
                                            {data_departments.filter((d) => !dept_search || (d.name || "").includes(dept_search) || (d.department_code || "").includes(dept_search)).length === 0 && (
                                                <div className="text-center text-secondary text-12 py-3">{t("department_access_not_found")}</div>
                                            )}
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* ส่วนที่ 4: ข้อมูลการเงิน & พาหนะ */}
                    <div className="card border shadow-sm rounded-4 mb-4">
                        <div className="card-body p-4">
                            <h6 className="fw-bold text-dark mb-4 pb-2 border-bottom" style={{ color: "#2B3674" }}>
                                <span className="text-primary me-2">•</span>
                                {t("section_financial_transport")}
                            </h6>

                            <div className="mb-2">
                                <span className="icon text-secondary me-2 text-14">{"\uf19c"}</span>
                                <span className="fw-bold text-14 text-dark">{t("bank_info_section")}</span>
                            </div>
                            <div className="row g-3 align-items-center mb-4">
                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">
                                        {t("bank_label")} <span className="text-danger">*</span>
                                    </label>
                                    <select className="form-select" value={bank} onChange={(e) => this.setState({ bank: e.target.value })}>
                                        {sortOptions(global.bank, { by: "name_th" }).map((b, idx) => (
                                            <option key={idx} value={b.value}>
                                                {b.name_th}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">
                                        {t("bank_account")} <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={t("account_no_placeholder")}
                                        value={account_no}
                                        onChange={(e) => this.setState({ account_no: e.target.value })}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">
                                        {t("account_name_label")} <span className="text-danger">*</span>
                                    </label>
                                    <input type="text" className="form-control" placeholder={t("full_name")} value={account_name} onChange={(e) => this.setState({ account_name: e.target.value })} />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("display_example_label")}</label>
                                    <div className="p-3 border rounded-3 bg-light d-flex align-items-center" style={{ minHeight: "60px" }}>
                                        {bank ? (
                                            <img
                                                alt=""
                                                className="me-3"
                                                width={40}
                                                height={40}
                                                src={require(`../../assets/images/bank/${global.bank.find((b) => b.value === bank)?.icon || "bank.png"}`)}
                                            />
                                        ) : (
                                            <div
                                                className="rounded bg-primary text-white d-flex align-items-center justify-content-center fw-bold me-3 wpx-40 hpx-40"
                                                style={{ backgroundColor: "#4c2d73 !important" }}
                                            >
                                                {bank}
                                            </div>
                                        )}
                                        <div>
                                            <div className="fw-bold text-14 text-dark">
                                                {t("account_name_colon")} {account_name}
                                            </div>
                                            <div className="text-secondary text-12">{this.formatBankAcct(account_no)}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="mb-3 mt-4">
                                <span className="icon text-secondary me-2 text-14">{"\uf5e1"}</span>
                                <span className="fw-bold text-14 text-dark">{t("vehicle_section")}</span>
                            </div>
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <div
                                        className={`p-3 border rounded-3 d-flex justify-content-between align-items-center transition-hover ${
                                            has_car ? "border-success bg-success-light" : "bg-light"
                                        }`}
                                    >
                                        <div className="d-flex align-items-center">
                                            <span className="icon text-24 text-danger me-3">{"\uf1b9"}</span>
                                            <div>
                                                <div className="fw-bold text-14 text-dark">{t("personal_car_label")}</div>
                                            </div>
                                        </div>
                                        <div className="form-check form-switch m-0">
                                            <input
                                                className="form-check-input mt-0 cursor-pointer"
                                                type="checkbox"
                                                role="switch"
                                                style={{ width: "40px", height: "20px" }}
                                                checked={has_car}
                                                onChange={(e) => this.setState({ has_car: e.target.checked })}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div
                                        className={`p-3 border rounded-3 d-flex justify-content-between align-items-center transition-hover ${
                                            has_motorcycle ? "border-success bg-success-light" : "bg-light"
                                        }`}
                                    >
                                        <div className="d-flex align-items-center">
                                            <span className="icon text-24 text-danger me-3">{"\uf21c"}</span>
                                            <div>
                                                <div className="fw-bold text-14 text-dark">{t("personal_motorcycle_label")}</div>
                                            </div>
                                        </div>
                                        <div className="form-check form-switch m-0">
                                            <input
                                                className="form-check-input mt-0 cursor-pointer"
                                                type="checkbox"
                                                role="switch"
                                                style={{ width: "40px", height: "20px" }}
                                                checked={has_motorcycle}
                                                onChange={(e) => this.setState({ has_motorcycle: e.target.checked })}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ส่วนที่ 5: ความชำนาญเครื่องพิมพ์ */}
                    <div className="card border shadow-sm rounded-4 mb-2">
                        <div className="card-body p-4">
                            <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-4">
                                <h6 className="fw-bold text-dark mb-0" style={{ color: "#2B3674" }}>
                                    <span className="text-primary me-2">•</span>
                                    {t("section_printer_expertise")}
                                </h6>
                                <span className="text-secondary text-12">{t("printer_priority_hint")}</span>
                            </div>

                            {/* Table Header */}
                            <div className="row text-secondary fw-bold text-12 border-bottom pb-2 mb-2 px-2">
                                <div className="col-1 text-center">{t("no")}</div>
                                <div className="col-5">{t("printer_skill_label")}</div>
                                {/* <div className="col-4">ระดับความชำนาญ</div> */}
                                <div className="col-2 text-center">{t("manage")}</div>
                            </div>

                            {/* Skill List */}
                            {printers.map((printer, index) => (
                                <div key={printer.id} className="row align-items-center py-2 px-2 border-bottom bg-white hover-bg-light transition-hover">
                                    <div className="col-1 text-center d-flex align-items-center justify-content-center">
                                        <div
                                            className="rounded-circle bg-warning-light text-dark fw-bold d-flex align-items-center justify-content-center"
                                            style={{ width: "24px", height: "24px", fontSize: "12px" }}
                                        >
                                            {index + 1}
                                        </div>
                                    </div>
                                    <div className="col-5">
                                        <span className="badge bg-light text-dark border px-3 py-2 fw-medium text-12 d-inline-flex align-items-center">
                                            <span className="icon text-primary me-2">{"\uf02f"}</span> {data_skill.find((b) => b.uid === printer.name)?.name}
                                            <span className="icon text-danger ms-2 cursor-pointer" onClick={() => this.handleRemovePrinter(printer.id)}>
                                                {"\uf00d"}
                                            </span>
                                        </span>
                                    </div>

                                    <div className="col-2 text-center">
                                        <div className="btn-group">
                                            <button className="btn btn-outline-secondary btn-sm bg-white px-2" onClick={() => this.movePrinter(index, "up")} disabled={index === 0}>
                                                <span className="icon">{"\uf0d8"}</span>
                                            </button>
                                            <button className="btn btn-outline-secondary btn-sm bg-white px-2" onClick={() => this.movePrinter(index, "down")} disabled={index === printers.length - 1}>
                                                <span className="icon">{"\uf0d7"}</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}

                            {/* Add Printer Toolbar */}
                            <div className="d-flex align-items-center gap-3 mt-4">
                                <Select
                                    className="form-control wpx-250"
                                    placeholder={t("select_printer_model_placeholder")}
                                    value={this.state.new_printer_select}
                                    options={activeOptions(
                                        [...data_skill]
                                            .sort((a, b) => (a.brand?.name || "").localeCompare(b.brand?.name || "") || a.name.localeCompare(b.name))
                                            .map((model) => ({
                                                is_active: model.is_active,
                                                value: model.uid,
                                                label: model.name,
                                                group: model.brand?.name || t("brand_other"),
                                            })),
                                        this.state.new_printer_select
                                    )}
                                    onChange={(value) => this.setState({ new_printer_select: value })}
                                />
                                <button className="btn btn-outline-primary bg-white d-flex align-items-center px-3" onClick={this.handleAddPrinter}>
                                    <span className="icon me-2">{"\uf067"}</span> {t("add_skill_button")}
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* ส่วนที่ 6: ลายเซ็น (Signature) */}
                    <div className="card border shadow-sm rounded-4 mb-2">
                        <div className="card-body p-4">
                            <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-4">
                                <h6 className="fw-bold text-dark mb-0" style={{ color: "#2B3674" }}>
                                    <span className="text-primary me-2">•</span>
                                    {t("section_signature")}
                                </h6>
                                <span className="text-secondary text-12">{t("technician_signature_desc")}</span>
                            </div>

                            {signature_edit_mode ? (
                                <div>
                                    <div className="text-secondary text-12 mb-2">{t("signature_pad_hint")}</div>
                                    <canvas
                                        ref={this.signatureCanvasRef}
                                        width={600}
                                        height={200}
                                        className="border rounded-3 bg-white w-100"
                                        style={{ touchAction: "none", cursor: "crosshair", maxWidth: "100%" }}
                                        onMouseDown={this.handleSignatureStart}
                                        onMouseMove={this.handleSignatureMove}
                                        onMouseUp={this.handleSignatureEnd}
                                        onMouseLeave={this.handleSignatureEnd}
                                        onTouchStart={this.handleSignatureStart}
                                        onTouchMove={this.handleSignatureMove}
                                        onTouchEnd={this.handleSignatureEnd}
                                    />
                                    <div className="d-flex gap-2 mt-3 flex-wrap">
                                        <button className="btn btn-outline-secondary bg-white px-3" onClick={this.clearSignaturePad}>
                                            <span className="icon me-2">{"\uf1f8"}</span> {t("clear_signature")}
                                        </button>
                                        <button className="btn btn-outline-primary bg-white px-3" onClick={this.openSignatureFilePicker}>
                                            <span className="icon me-2">{"\uf093"}</span> {t("upload_signature")}
                                        </button>
                                        <button className="btn btn-outline-secondary bg-white px-3" onClick={this.cancelSignatureEdit}>
                                            {t("cancel")}
                                        </button>
                                        <button className="btn btn-primary px-4 ms-auto" onClick={this.saveSignature}>
                                            <span className="icon me-2">{"\uf0c7"}</span> {t("save_signature")}
                                        </button>
                                    </div>
                                </div>
                            ) : signature ? (
                                <div>
                                    <div className="border rounded-3 bg-light d-flex align-items-center justify-content-center p-3" style={{ minHeight: "160px" }}>
                                        <img src={signature} alt="" style={{ maxHeight: 150, maxWidth: "100%" }} />
                                    </div>
                                    <div className="d-flex gap-2 mt-3 flex-wrap">
                                        <button className="btn btn-outline-primary bg-white px-3" onClick={this.openSignaturePad}>
                                            <span className="icon me-2">{"\uf044"}</span> {t("edit_signature")}
                                        </button>
                                        <button className="btn btn-outline-primary bg-white px-3" onClick={this.openSignatureFilePicker}>
                                            <span className="icon me-2">{"\uf093"}</span> {t("upload_signature_again")}
                                        </button>
                                        <button className="btn btn-outline-danger bg-danger-light border-danger text-danger px-3" onClick={this.removeSignature}>
                                            <span className="icon me-2">{"\uf2ed"}</span> {t("remove_signature")}
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                <div className="border rounded-3 bg-light d-flex flex-column align-items-center justify-content-center p-4 text-secondary" style={{ minHeight: "160px" }}>
                                    <span className="icon text-24 mb-2">{"\uf5b7"}</span>
                                    <div className="text-14 mb-3">{t("no_signature_yet")}</div>
                                    <div className="d-flex gap-2 flex-wrap justify-content-center">
                                        <button className="btn btn-primary px-4" onClick={this.openSignaturePad}>
                                            <span className="icon me-2">{"\uf067"}</span> {t("add_signature")}
                                        </button>
                                        <button className="btn btn-outline-primary bg-white px-4" onClick={this.openSignatureFilePicker}>
                                            <span className="icon me-2">{"\uf093"}</span> {t("upload_signature")}
                                        </button>
                                    </div>
                                </div>
                            )}

                            {/* input จริงของปุ่มอัปโหลด - ซ่อนไว้ ใช้ร่วมกันทั้ง 3 สถานะด้านบน */}
                            <input
                                type="file"
                                accept="image/*"
                                ref={this.signatureFileRef}
                                onChange={this.handleSignatureFile}
                                className="d-none"
                            />
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer className="border-top p-3 bg-white d-flex justify-content-between align-items-center">
                    <div>
                        {modal_update && can("technicians.delete") && (
                            <button className="btn btn-outline-danger px-4 d-flex align-items-center bg-danger-light border-danger text-danger rounded-3" onClick={() => this.Delete(uid)}>
                                <span className="icon me-2 text-14">{"\uf2ed"}</span> {t("delete_item")}
                            </button>
                        )}
                    </div>
                    <div className="d-flex gap-2">
                        <button className="btn btn-outline-secondary px-4 bg-white rounded-3" onClick={() => this.setState({ modal_create: false, modal_update: false })}>
                            <span className="icon me-2 text-14">{"\uf0e2"}</span> {t("cancel")}
                        </button>
                        {(modal_create || can("technicians.update")) && (
                          <button
                              className="btn btn-primary px-5 d-flex align-items-center rounded-3 shadow-sm"
                              onClick={this.CreateUpdate}
                              style={{ backgroundColor: "#2B3674", borderColor: "#2B3674" }}
                          >
                              <span className="icon me-2 text-14">{"\uf0c7"}</span> {t("save")}
                          </button>
                        )}
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    );
  }
}